import React from 'react';

import { faPlus } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { useDialogs } from '../../hooks';

const NewStatusButton = () => {
  const { handleNewStatusClick: handleClick } = useDialogs();

  return (
    <div className="flex h-[40px] items-center">
      <Button className="rounded-xl" onClick={handleClick} size="icon" variant="outline">
        <FontAwesomeIcon icon={faPlus} />
      </Button>
    </div>
  );
};

export default NewStatusButton;
